export const createQueryString = (params?: {
    filter?: object;
    page?: number;
    search?: string;
    itemsPerPage?: number;
    sort?: string;
}): string => {
    if (!params) {
        return "";
    }

    const { filter, ...restParams } = params;

    const stringParams: Record<string, string> = Object.entries(
        restParams,
    ).reduce(
        (acc, [key, value]) => ({
            ...acc,
            [key]: String(value),
        }),
        {} as Record<string, string>,
    );

    const searchParams = new URLSearchParams(stringParams);

    let filterString = "";
    if (filter) {
        filterString = Object.entries(filter)
            .map(([key, value]) => `filter[${key}]=${String(value)}`)
            .join("&");
    }

    const queryString = searchParams.toString();

    if (queryString && filterString) return `${queryString}&${filterString}`;
    if (filterString) return filterString;
    if (queryString) return queryString;
    return "";
};
